import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { getPopularityList } from "../service/inspire-service";
import { Typography, Paper, IconButton, Divider, Card } from "@mhome/ui";
import { useComponentBackgroundColor } from "../common/adaptive-theme-provider";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import { PremadesList } from "./premade-gallery-view";
import useApiCall from "../common/api-call";
import { useWebSocket } from "../ws/websocket";
import RefreshIcon from "@mui/icons-material/Refresh";
import LoadingSpinner from "../common/loading";
import useMediaQuery from "@mui/material/useMediaQuery";
import ResponsiveCardGrid from "../common/responsive-card-grid";

const PremadePopularityPreview = () => {
  const getComponentBgColor = useComponentBackgroundColor();
  const [premades, setPremades] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { apiCall } = useApiCall();
  const { sendAndWaitWs } = useWebSocket();
  const isLarge = useMediaQuery("(min-width:1200px)");
  const isMedium = useMediaQuery("(min-width:600px)");

  useEffect(() => {
    fetchPreview();
  }, []);

  useEffect(() => {
    if (premades.length > 0) {
      console.debug(premades);
    }
  }, [premades]);

  const fetchPreview = async () => {
    setLoading(true);
    try {
      const resp = await getPopularityList(sendAndWaitWs, 8, "adopt", "");
      if (resp && !resp.error) {
        setPremades(resp.premades?.slice(0, 8) || []);
      }
    } finally {
      setLoading(false);
    }
  };

  let maxToShow = 4;
  if (isLarge) maxToShow = 8;
  else if (isMedium) maxToShow = 6;

  const displayPremades = premades.slice(
    0,
    Math.max(4, Math.min(maxToShow, premades.length))
  );

  const handleAdopt = (data) => {
    history.push(
      `/automation/overview?premadeId=${data.id}&premadeVersion=${data.version}`
    );
  };

  return (
    <div style={{ padding: "16px" }}>
      <Paper
        style={{
          padding: "16px",
          marginBottom: "16px",
          borderRadius: "16px",
          position: "relative",
          backgroundColor: getComponentBgColor("hsl(var(--card))"),
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
            Premade Popularity Ranking
          </Typography>
          <IconButton
            size="small"
            onClick={() => history.push("/premade/popularity")}
          >
            <ChevronRightIcon />
          </IconButton>
        </div>
        <Divider style={{ marginTop: "8px", marginBottom: "8px" }} />

        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 60,
            }}
          >
            <LoadingSpinner />
          </div>
        ) : premades.length > 0 ? (
          <PremadesList premades={displayPremades} onAdopt={handleAdopt} />
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <Typography>No Premades Data</Typography>
            <IconButton size="small" onClick={fetchPreview} title="refresh">
              <RefreshIcon />
            </IconButton>
          </div>
        )}
      </Paper>
    </div>
  );
};

const PremadesList = ({ premades, onAdopt }) => {
  const getComponentBgColor = useComponentBackgroundColor();

  return (
    <>
      {premades.length > 0 ? (
        <ResponsiveCardGrid breakpoints={{ xs: 1, sm: 2, md: 3 }}>
          {premades.map((premade, index) => (
            <Card
              key={index}
              elevation={0}
              onClick={() => onAdopt(premade)}
              style={{
                backgroundColor: getComponentBgColor("hsl(var(--card))"),
                cursor: "pointer",
                transition: "background 0.2s, transform 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "hsl(var(--accent))";
                e.currentTarget.style.transform = "scale(1.03)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor =
                  getComponentBgColor("hsl(var(--card))");
                e.currentTarget.style.transform = "scale(1)";
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                  padding: "8px",
                  textAlign: "left",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexGrow: 1,
                  }}
                >
                  <Typography
                    variant="body1"
                    component="div"
                    style={{
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 4,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxHeight: "4.5em",
                      marginBottom: 0,
                    }}
                  >
                    {premade.summary}
                  </Typography>
                </div>
              </div>
            </Card>
          ))}
        </ResponsiveCardGrid>
      ) : (
        <Typography
          variant="body1"
          style={{ color: "hsl(var(--muted-foreground))" }}
        >
          Premade automations will be available soon.
        </Typography>
      )}
    </>
  );
};

export default PremadePopularityPreview;
